import { IA_SEARCH_LOAD, IA_SEARCH_UNLOAD, IA_SEARCH_RESULTS_LOAD } from "../../actions/Constants";

const defaultState = {
  results: null,
  loading: false,
  error: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case IA_SEARCH_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case IA_SEARCH_RESULTS_LOAD:
      return {
        ...state,
        results: action.payload,
        loading: false,
        error: null,
      };
    case IA_SEARCH_UNLOAD:
      return {
        ...defaultState,
      };
    default:
      return state;
  }
};